import { call, put } from '@redux-saga/core/effects';
import { api, notify, apiErrorHandler } from 'services';
import {
  UpdateVehicleTypeActions as Actions,
  UpdateVehicleTypeRequestAction as RequestAction,
} from 'store/ducks/vehicleTypes';

export function* updateVehicleTypeRequest(action: any) {
  const { id, putData, onSuccess, onFailure }: RequestAction = action;
  try {
    yield call(api.put, `vehicle-types/${id}`, putData);
    onSuccess && onSuccess();
    notify('success', 'Veículo atualizado com sucesso');
    yield put(Actions.success());
  } catch (error) {
    const { errorMessage, validationErrors } = apiErrorHandler(error);
    onFailure && onFailure();
    notify('error', errorMessage);
    yield put(Actions.failure(errorMessage, validationErrors));
  }
}
